import clsx from 'clsx';

const container = (dir) => clsx('flex gap-4', dir === 'col' ? 'flex-col' : 'flex-row');
const cardContainer = (toggled, className, hasErrors, size) => clsx('flex border-solid w-full', 'cursor-pointer rounded-md transition-colors duration-200 ease-in-out', toggled ? 'nj-radio-button-selected' : 'ng-radio-button', className, hasErrors && '!bg-red-50 !border-red-500', size === 'small' ? 'px-4 py-2' : size === 'medium' ? 'px-4 py-3' : 'p-4');
const cardBox = 'flex w-full gap-2 items-center border-transparent';
const wrapper = (center) => clsx(`flex grow items-center gap-2 ${center ? 'justify-center' : ''}`);
const body = 'flex flex-col gap-1';
const label = (size) => clsx('text-black font-bold text-paragraph', size === 'small' || size === 'medium' ? 'leading-tight' : 'leading-normal');
const placeholder = 'text-body text-gray-900 leading-tight';
const icon = (size) => clsx(size === 'small' || size === 'medium' ? 'w-4 h-4' : 'w-6 h-6');
const descriptionClassNames = 'flex w-full pt-1.5 text-gray-600 font-medium text-caption1';
var classNames = {
    cardBox,
    cardContainer,
    container,
    wrapper,
    body,
    label,
    placeholder,
    icon,
    descriptionClassNames,
};

export { classNames as default };
